import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { setMessage } from '@store/messageSlice';

function ProtectedRoute({ children }) {
  const dispatch = useDispatch();
  const userInfo = localStorage.getItem('userInfo');
  const companyCode = localStorage.getItem('companyCode');
  const [valid, setValid] = useState(true); // 기본은 유효하다고 가정

  useEffect(() => {

    if (!companyCode) {
      dispatch(
        setMessage({
          message: '회사코드가 없습니다. <br/> 초기화면으로 이동합니다.',
          type: 'error',
        })
      );
      setValid(false);
    }

    if (!userInfo) {
      dispatch(
        setMessage({
          message: '로그인이 필요합니다. <br/> 초기화면으로 이동합니다.',
          type: 'error',
        })
      );
      setValid(false);
    }

  }, [dispatch, userInfo, companyCode]);

  // 메시지 전송 후 ErrorAlert가 redirect 처리
  if (!valid) return null;

  return children;
}

export default ProtectedRoute;
